import { reactive } from 'vue';

interface SearchConfig {
  rules: any;
  fields: any;
  settings: any;
  model: any;
}

export default () => {
  const apiurl_config: SearchConfig = {
    settings: {
      name: '表单名称',
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '接口名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写接口名称',
      },
      {
        type: 'input',
        name: 'url',
        label: '绝对路径url',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '绝对路径url',
      },
    ],
    rules: reactive({
      name: [],
    }),
    model: {},
  };
  const apiurl_columns = [
    {
      title: '接口名称',
      dataIndex: 'name',
    },
    {
      title: 'url',
      dataIndex: 'url',
    },
  ];
  const apiurl_ConfigOptions = {
    is_active: [
      { name: '全部', value: '' },
      { name: '正常', value: true },
      { name: '作废', value: false },
    ],
  };
  return {
    searchConfig: apiurl_config,
    searchConfigOptions: apiurl_ConfigOptions,
    getData: '/permission/query_apiurl_list',
    columns: apiurl_columns,
  };
};
